<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    :width="$selectByLang('350px', '390px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('80px', '120px')" label-position="left">
      <el-form-item v-show="operation===0" :label="$t('queryJob.takeoffTime')">
        <el-date-picker
          v-model="form.atd"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          :editable="false"
        />
      </el-form-item>
      <el-form-item v-show="operation===1" :label="$t('CargoMsg.Cargo_ArrivalTime')">
        <el-date-picker
          v-model="form.ata"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
        />
      </el-form-item>
      <el-form-item v-show="operation!==0&&operation!==1" :label="$t('queryJob.deliveryTime')">
        <el-date-picker
          v-model="form.handOffDateTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Flight')">{{ form.flightDescription ? form.flightDescription.flightNo : '' }}</el-form-item>
      <el-form-item :label="$t('queryJob.dateOfDeparture')">{{ ColumnUtils.dateLabelFunc(form.etd) }}</el-form-item>
      <el-form-item
        :label="$t('SeaExport.AirlineCompany')"
      >{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', form.flightDescription ? form.flightDescription.carrierId : 0, 'chineseName') }}</el-form-item>
      <el-form-item
        :label="$t('Payment.portOfLoading')"
      >{{ loadingPortCodeLabel }}</el-form-item>
      <el-form-item
        :label="$t('Payment.portOfDestination')"
      >{{ destinationPortCodeLable }}</el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirPort } from '@/class/model/mdm/AirPort'
import { getFlight, updateFlight } from '@/api/booking/flight'

export default {
  name: 'UpdateFlightDialog',
  props: {
    visible: { type: Boolean, required: true },
    operation: { type: Number, required: true },
    flight: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: null,
      title: '',
      form: {
        atd: '',
        ata: '',
        handOffDateTime: '',
        etd: '',
        flightDescription: {
          flightNo: '',
          carrierId: 0,
          loadingPortCode: '',
          destinationPortCode: ''
        }
      },
      loadingPortCodeLabel: '',
      destinationPortCodeLable: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loading = getLoading4Cxt(this)
        getFlight(this.flight.uuid).then(res => {
          this.form = res.data
          this.loadingPortCodeLabel = ''
          this.destinationPortCodeLable = ''
          if (this.form.flightDescription) {
            AirPort.getAirportByCode(this.form.flightDescription.loadingPortCode).then(port => {
              if (port) {
                this.loadingPortCodeLabel = '[' + port.code + ']' + port.chineseName
              }
            })
            AirPort.getAirportByCode(this.form.flightDescription.destinationPortCode).then(port => {
              if (port) {
                this.destinationPortCodeLable = '[' + port.code + ']' + port.chineseName
              }
            })
          }
        }).finally(() => {
          this.loading.close()
        })
        switch (this.operation) {
          case 0:
            this.title = this.$t('queryJob.trackingFlight')
            break
          case 1:
            this.title = this.$t('queryJob.trackingArrival')
            break
          default:
            this.title = this.$t('queryJob.trackingDelivery')
            break
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.ColumnUtils = ColumnUtils
  },
  methods: {
    clickHandler() {
      if (this.operation === 0) {
        if (!this.form.atd) {
          this.$message.info(this.$t('queryJob.enterDepartureTime'))
          return
        }
      } else if (this.operation === 1) {
        if (!this.form.ata) {
          this.$message.info(this.$t('queryJob.enterArrivalTime'))
          return
        }
      } else {
        if (!this.form.handOffDateTime) {
          this.$message.info(this.$t('queryJob.enterDeliveryTime'))
          return
        }
      }
      updateFlight(this.form, { selectiveType: 'atd,ata,handOffDateTime' }).then(res => {
        const data = res.data
        this.flight.atd = data.atd
        this.flight.ata = data.ata
        this.flight.handOffDateTime = data.handOffDateTime
        this.flight.version = data.version
        this.$message.success(this.$t('Message.SaveSucceed'))
        this.$emit('callback')
        this.innerVisible = false
      })
    }
  }
}
</script>
